import { Button } from '@mantine/core';
import { useEffect, useRef } from 'react';
import { primaryColor } from '../../../constants/theme';
import { IconBrandGoogleFilled } from '@tabler/icons-react';

declare global {
  interface Window {
    google?: any;
  }
}

type Props = {
  onIdToken: (idToken: string) => void; // send to your backend
  text?: 'continue_with' | 'signup_with' | 'signin_with';
  width?: number;
};

export const GoogleSignOnButton = ({
  onIdToken,
  text = 'signin_with',
  width = 300,
}: Props) => {
  const googleButtonRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const loadGoogleScript = () => {
      if (window.google) {
        initializeGoogleSignIn();
        return;
      }

      const script = document.createElement('script');
      script.src = 'https://accounts.google.com/gsi/client';
      script.onload = initializeGoogleSignIn;
      document.head.appendChild(script);
    };

    const initializeGoogleSignIn = () => {
      if (window.google && googleButtonRef.current) {
        window.google.accounts.id.initialize({
          client_id: import.meta.env.VITE_GOOGLE_WEB_CLIENT,
          callback: handleCredentialResponse,
        });

        window.google.accounts.id.renderButton(googleButtonRef.current, {
          theme: 'outline',
          size: 'large',
          text: 'continue_with',
          width: width,
          logo_alignment: 'center',
          IconBackground: primaryColor,
        });
      }
    };

    const handleCredentialResponse = (response: any) => {
      console.log('Google response 2:', response);
      if (response.credential) {
        onIdToken(response.credential);
      }
    };

    loadGoogleScript();
  }, [onIdToken, text, width]);

  const triggerClick = () => {
    const container = document.getElementById('googleButton');
    const inner = container?.querySelector<HTMLButtonElement | HTMLDivElement>(
      'button, div[role="button"], [role="button"], [data-provider="google"]'
    );
    if (inner) {
      inner.click();
    } else {
      console.error('Google button inner element not found');
      window.google?.accounts.id.prompt();
    }
  };

  return (
    <>
      <div
        id="googleButton"
        ref={googleButtonRef}
        style={{ display: 'none' }}
      ></div>
      <Button
        color={primaryColor}
        radius={'lg'}
        size={'md'}
        onClick={triggerClick}
        leftSection={<IconBrandGoogleFilled />}
      >
        Continue with Google
      </Button>
    </>
  );
};
